import { readConfig } from './config';
import {
  activateHugin,
  autoDecorateHuginLinks,
  createDeferredHugin,
  hasDoNotTrack,
  isTrackingDisabled,
} from './tracker';
import { readFirstTouchContext } from './utm';

export function bootstrap(): void {
  const config = readConfig();
  if (!config) {
    // Missing or invalid embed — bail silently so the host page is unaffected.
    // Common causes: no built-in API URL (non-CI build), or loaded outside
    // document context where document.currentScript is unavailable.
    return;
  }

  if (config.doNotTrack && hasDoNotTrack()) return;

  // Capture UTM/referrer now, while the original URL is intact.
  const firstTouchContext = readFirstTouchContext();
  autoDecorateHuginLinks(firstTouchContext);

  if (!config.autoTrack || isTrackingDisabled()) {
    window.hugin = createDeferredHugin(config, firstTouchContext);
    return;
  }

  activateHugin(config, firstTouchContext);
}
